import {
    MdDashboard,
    MdPeople,
    MdBarChart,
    MdShoppingCart,
    MdPayment,
    MdCategory,
    MdOutlineLocalOffer,
    MdViewList,
} from 'react-icons/md';
import BackOfficeDashboard from 'views/backoffice/dashboard/index';
import BackOfficeUsers from 'views/backoffice/users/index';
import UserForm from 'views/backoffice/users/form';
import BackOfficeLeads from 'views/backoffice/leads/index';
import BackOfficeOffers from 'views/backoffice/offers/index';
import BackOfficeOfferDetail from 'views/backoffice/offers/detail';
import BackOfficePurchaseOrders from 'views/backoffice/purchaseOrders/index';
import BackOfficePaymentLogs from 'views/backoffice/paymentLogs/index';
import BackOfficeIndustries from 'views/backoffice/industries/index';
import IndustryForm from 'views/backoffice/industries/form';
import BackOfficeFormFields from 'views/backoffice/formFields/index';
import FormFieldForm from 'views/backoffice/formFields/form';

const backOfficeRoutes: RoutesType[] = [
    // {
    //     name: 'Dashboard',
    //     layout: '/back-office',
    //     path: '/dashboard',
    //     icon: <MdDashboard className="h-5 w-5" />,
    //     component: <BackOfficeDashboard />,
    //     menu: true,
    // },
    {
        name: 'Users',
        layout: '/back-office',
        path: '/users',
        icon: <MdPeople className="h-5 w-5" />,
        component: <BackOfficeUsers />,
        menu: true,
    },
    {
        name: 'Edit User',
        layout: '/back-office',
        path: '/users/edit/:id',
        component: <UserForm />,
        menu: false,
    },
    {
        name: 'Offers',
        layout: '/back-office',
        path: '/offers',
        icon: <MdOutlineLocalOffer className="h-5 w-5" />,
        component: <BackOfficeOffers />,
        menu: true,
    },
    {
        name: 'Offer Detail',
        layout: '/back-office',
        path: '/offers/:offerType/:id',
        component: <BackOfficeOfferDetail />,
        menu: false,
    },
    {
        name: 'Leads',
        layout: '/back-office',
        path: '/leads',
        icon: <MdBarChart className="h-5 w-5" />,
        component: <BackOfficeLeads />,
        menu: true,
    },
    {
        name: 'Purchase Orders',
        layout: '/back-office',
        path: '/purchase-orders',
        icon: <MdShoppingCart className="h-5 w-5" />,
        component: <BackOfficePurchaseOrders />,
        menu: true,
    },
    {
        name: 'Payment Logs',
        layout: '/back-office',
        path: '/payment-logs',
        icon: <MdPayment className="h-5 w-5" />,
        component: <BackOfficePaymentLogs />,
        menu: true,
    },
    {
        name: 'Industries',
        layout: '/back-office',
        path: '/industries',
        icon: <MdCategory className="h-5 w-5" />,
        component: <BackOfficeIndustries />,
        menu: true,
    },
    {
        name: 'Create Industry',
        layout: '/back-office',
        path: '/industries/create',
        component: <IndustryForm />,
        menu: false,
    },
    {
        name: 'Edit Industry',
        layout: '/back-office',
        path: '/industries/edit/:id',
        component: <IndustryForm />,
        menu: false,
    },
    {
        name: 'Form Fields',
        layout: '/back-office',
        path: '/form-fields',
        icon: <MdViewList className="h-5 w-5" />,
        component: <BackOfficeFormFields />,
        menu: true,
    },
    {
        name: 'Create Form Field',
        layout: '/back-office',
        path: '/form-fields/create',
        component: <FormFieldForm />,
        menu: false,
    },
    {
        name: 'Edit Form Field',
        layout: '/back-office',
        path: '/form-fields/edit/:id',
        component: <FormFieldForm />,
        menu: false,
    },
    // {
    //     name: 'Settings',
    //     layout: '/back-office',
    //     path: '/settings',
    //     icon: <MdSettings className="h-5 w-5" />,
    //     component: <BackOfficeSettings />,
    //     menu: true,
    // },
];

export default backOfficeRoutes;
